module.exports = __webpack_public_path__ + "static/img/face22.4a7beac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face22.jpg
// module id = vJMf
// module chunks = 0